import { render, staticRenderFns } from "./futureLab.vue?vue&type=template&id=48c6d4a6&scoped=true"
import script from "./futureLab.vue?vue&type=script&lang=js"
export * from "./futureLab.vue?vue&type=script&lang=js"
import style0 from "./futureLab.vue?vue&type=style&index=0&id=48c6d4a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c6d4a6",
  null
  
)

export default component.exports